const win$1 = window;
{
  win$1.AS || (win$1.AS = {});
  win$1.o_global || (win$1.o_global = {});
  win$1.o_util || (win$1.o_util = {});
}
win$1.__toggles__ || (win$1.__toggles__ = {});
function get$1(name) {
  const parts = document.cookie.split(/;\s*/);
  const n = `${name}=`;
  const cookieValue = parts.find((part) => {
    return part.startsWith(n);
  });
  if (cookieValue) {
    return decodeURIComponent(cookieValue.replace(n, ""));
  }
  return void 0;
}
const win = window;
{
  win.AS || (win.AS = {});
  win.o_global || (win.o_global = {});
  win.o_util || (win.o_util = {});
}
win.__toggles__ || (win.__toggles__ = {});
const { o_global, o_util, __toggles__ } = win;
function assignNamespace(parent, key, implementation, legacy) {
  parent[key] = Object.assign(parent[key] ?? {}, implementation, legacy);
  return parent[key];
}
function jsonParseSafe(value) {
  try {
    return typeof value === "string" ? JSON.parse(value) : void 0;
  } catch {
    return void 0;
  }
}
const COOKIE_PREFIX = "toggle_";
const cookieMap = { true: 1, false: 0, "1": 1, "0": 0 };
function normalize(toggle, defaultValue, defaultPayload) {
  if (toggle === void 0) {
    return [!!defaultValue, false, defaultPayload];
  }
  if (Array.isArray(toggle)) {
    return [!!toggle[0], !!toggle[1], jsonParseSafe(toggle[2]) ?? defaultPayload];
  }
  return [!!toggle, false, defaultPayload];
}
function normalizeLegacy(toggle, defaultValue, defaultPayload) {
  if (toggle === void 0) {
    return [!!defaultValue, false, defaultPayload];
  }
  if (!!toggle === false) {
    return [false, true, defaultPayload];
  }
  return [true, false, defaultPayload];
}
function getToggle(toggleName, defaultValue = true, defaultPayload = void 0) {
  var _a;
  const rawToggle = __toggles__[toggleName];
  const rawLegacy = (_a = o_global.toggles) == null ? void 0 : _a[toggleName];
  const toggle = rawToggle ? normalize(rawToggle, defaultValue, defaultPayload) : normalizeLegacy(rawLegacy, defaultValue, defaultPayload);
  if (!toggle[1]) {
    return [toggle[0], toggle[2]];
  }
  const localStatus = get$1(COOKIE_PREFIX + toggleName);
  if (!localStatus || cookieMap[localStatus] === void 0) {
    return [toggle[0], toggle[2]];
  }
  return [!!cookieMap[localStatus], toggle[2]];
}
function get$2(toggleName, defaultValue = false) {
  const [res] = getToggle(toggleName, defaultValue, void 0);
  return res;
}
assignNamespace(o_util, "toggle", { get: get$2, getToggle });
const otto = win$1.otto ?? {};
const tracking = otto.tracking;
const submitEvent = tracking.submitEvent;
const submitEventMerge = tracking.submitEventMerge;
const submitMerge = tracking.submitMerge;
const submitMove = tracking.submitMove;
const submitMiniAction = tracking.submitMiniAction;
const createEventMergeContext = tracking.createEventMergeContext;
const trackOnNextPageImpression = tracking.trackOnNextPageImpression;
const createContext = tracking.createContext;
const replaceContext = tracking.replaceContext;
const closeContext = tracking.closeContext;
const getPageMergeId = tracking.getPageMergeId;
const createPage = tracking.createPage;
function get() {
  return tracking;
}
export {
  closeContext,
  createContext,
  createEventMergeContext,
  createPage,
  get,
  getPageMergeId,
  replaceContext,
  submitEvent,
  submitEventMerge,
  submitMerge,
  submitMiniAction,
  submitMove,
  trackOnNextPageImpression,
  tracking
};
/*                                     */
